import IMask from "imask"

export default function() {
    return (value, options) => IMask.pipe(value, options)
}